import React, { useState, useEffect } from 'react';
import { stockService } from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
    const [stats, setStats] = useState({ totalItems: 0, totalValue: 0, alerts: 0 });
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // Fonction pour charger les données
    const fetchStats = () => {
        stockService.getAllProducts().then(data => {
            if (data && Array.isArray(data)) {
                const total = data.length;
                const value = data.reduce((acc, p) => acc + (parseFloat(p.prix_achat_ht || 0) * parseInt(p.stock_actuel || 0)), 0);
                const lowStock = data.filter(p => parseInt(p.stock_actuel) <= parseInt(p.stock_min)).length;
                setStats({ totalItems: total, totalValue: value, alerts: lowStock });
            }
        }).catch(err => console.error("Erreur de stats:", err));
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        setMessage({ text: '', type: '' });

        try {
            const result = await stockService.importCSV(file);
            if (result.success) {
                setMessage({ text: result.message, type: 'success' });
                fetchStats(); // Rafraîchir les stats après l'import
            } else {
                setMessage({ text: result.message, type: 'error' });
            }
        } catch (error) {
            setMessage({ text: "Erreur lors de la connexion au serveur", type: 'error' });
        } finally {
            setUploading(false);
            e.target.value = ''; // Reset l'input
        }
    };

    return (
        <div className="dashboard-container">
            <h1>Tableau de Bord</h1>

            {/* SECTION STATS */}
            <div className="stats-container">
                <div className="stat-card">
                    <span className="stat-label">Références Produits</span>
                    <span className="stat-value">{stats.totalItems}</span>
                </div>

                <div className="stat-card ok-border">
                    <span className="stat-label">Valeur du Stock (HT)</span>
                    <span className="stat-value ok-text">
                        {stats.totalValue.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
                    </span>
                </div>

                <div className={`stat-card ${stats.alerts > 0 ? 'ko-border' : ''}`}>
                    <span className="stat-label">Alertes Réappro</span>
                    <span className={`stat-value ${stats.alerts > 0 ? 'ko-text' : ''}`}>
                        {stats.alerts}
                    </span>
                </div>
            </div>

            {/* SECTION IMPORTATION CSV */}
            <div className="import-section">
                <h3>Mise à jour du Stock</h3>
                <p>Importez votre fichier CSV standardisé pour rafraîchir les données globales.</p>

                <div className="upload-box">
                    <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileUpload}
                        id="csv-input"
                        style={{ display: 'none' }}
                        disabled={uploading}
                    />
                    <label htmlFor="csv-input" className={`upload-btn ${uploading ? 'disabled' : ''}`}>
                        {uploading ? '⏳ Importation...' : '📁 Choisir le fichier CSV'}
                    </label>
                </div>

                {message.text && (
                    <div className={`status-message ${message.type}`}>
                        {message.text}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;